import { create } from 'zustand';
import { superAdminSchoolService } from '@/services/superAdmin/schoolService';

export const useSuperAdminSchoolStore = create((set, get) => ({
  globalSchools: [],
  selectedSchool: null,
  loading: false,
  error: null,
  
  fetchAllSchools: async () => {
    set({ loading: true, error: null });
    try {
      const res = await superAdminSchoolService.getAllSchools(1, 100);
      set({ globalSchools: res.data.items || [], loading: false });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },
  
  fetchSchoolsByOrg: async (orgId) => {
    set({ loading: true, error: null });
    try {
      const res = await superAdminSchoolService.getSchoolsByOrganization(orgId);
      set({ globalSchools: res.data.items || [], loading: false });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  fetchSchoolById: async (id) => {
    set({ loading: true, error: null });
    try {
      const res = await superAdminSchoolService.getSchoolById(id);
      if (res.data) {
        set({ selectedSchool: res.data, loading: false });
      } else {
        set({ error: 'School not found', loading: false });
      }
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  createSchool: async (data) => {
    set({ loading: true, error: null });
    try {
      await superAdminSchoolService.createSchool(data);
      // Refresh list
      await get().fetchAllSchools();
      return true;
    } catch (err) {
      set({ error: err.message, loading: false });
      throw err;
    }
  },

  updateSchool: async (id, data) => {
    set({ loading: true, error: null });
    try {
      await superAdminSchoolService.updateSchool(id, data);
      await get().fetchAllSchools();
      return true;
    } catch (err) {
      set({ error: err.message, loading: false });
      throw err;
    }
  },

  schoolConfiguration: null,

  fetchSchoolConfiguration: async (id) => {
    try {
      const res = await superAdminSchoolService.getSchoolConfiguration(id);
      set({ schoolConfiguration: res.data });
      return res.data;
    } catch (err) {
      console.warn('School configuration fetch error:', err);
      return null;
    }
  },

  saveSchoolConfiguration: async (id, configData, isUpdate = false) => {
    set({ loading: true, error: null });
    try {
      const res = await superAdminSchoolService.createSchoolConfiguration(id, configData);

      await get().fetchSchoolConfiguration(id);
      await get().fetchSchoolById(id);
      set({ loading: false });
      return res.data;
    } catch (err) {
      set({ error: err.message, loading: false });
      throw err;
    }
  },

  updateSchoolConfiguration: async (id, configData) => {
    return get().saveSchoolConfiguration(id, configData, true);
  },
}));
